'use strict';

wbApp.directive('wbSecurityShow', ['securitySvc', '$translate',
    function (securitySvc, $translate) {
        return {
            restrict: 'A',
            priority: 100000,
            link: function link($scope, element, attributes) {
                var roles = attributes.wbSecurityShow;
                var shouldReplaceContent = attributes.wbSecurityUnauthorizedContent;
                var r = $scope.$eval(roles);
                if (!securitySvc.isInRole(r)) {
                    if (shouldReplaceContent) {
                        element.html("<div class='alert alert-danger'><h1>"+ $translate.instant('TXT_MESSAGE_FORBIDEN_VIEW') + "</h1></div>");
                    } else {
                        element.hide();
                    }
                }
            }
        }
    }]);